import React from 'react';
import './App.css';
import AziendaZeroLayout from "./layouts/AziendaZeroLayout";

class App extends React.Component {

    constructor(props) {
        super(props)
    }

    componentDidMount() {
        require("bootstrap-italia/dist/js/bootstrap-italia.min");
        require("bootstrap-italia/dist/css/bootstrap-italia.min.css");
    }

    render() {

        return (
            <AziendaZeroLayout/>
        );
    }
}

export default App;
